import { ConditionInput, QueryParams, SearchInput, SortingInput } from 'src/graphql/types';

export const DEFAULT_CONVERSATION_LIMIT = 40;

export interface BuildGetConversationVariablesOptions {
  filter?: ConditionInput[];
  sort?: SortingInput | SortingInput[];
  limit?: number;
  searchParams?: SearchInput;
  includeDeleted?: boolean;
  includeAttachments?: boolean;
  // custom-attribute JSON paths (e.g. `customAttributes.warranty_count::text`) to project per row.
  dynamicAttributePaths?: string[];
}

/**
 * Builds the GetConversation query variables. Extracted as a pure function so the dormant-by-default
 * custom-attribute projection (`@include(if: $hasCustomAttributes)`) is unit-testable without rendering.
 */
export function buildGetConversationVariables(options: BuildGetConversationVariablesOptions) {
  const {
    filter = [],
    limit = DEFAULT_CONVERSATION_LIMIT,
    sort,
    searchParams,
    includeDeleted,
    includeAttachments,
  } = options;

  const params: QueryParams = {
    filters: filter,
    sorting: sort,
    limit,
    offset: 0,
    includeDeleted,
  };

  if (searchParams) {
    params.searchParams = searchParams;
  }

  return {
    params,
    skipTotalRecords: !!searchParams,
    includeAttachments: !!includeAttachments,
  };
}
